var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { addNode } from "../RicosContentAPI/builder-utils";
class Builder {
  constructor(content, onRender) {
    __publicField(this, "onRender");
    __publicField(this, "content");
    this.content = content;
    this.onRender = onRender;
  }
  add(addNodeParams) {
    this.content = addNode(addNodeParams);
    return this;
  }
  append(node) {
    return this.add({ node, content: this.content });
  }
  insertBefore(id, node) {
    return this.add({ node, content: this.content, before: id });
  }
  insertAfter(id, node) {
    return this.add({ node, content: this.content, after: id });
  }
  insertAt(index, node) {
    return this.add({ node, content: this.content, index });
  }
  render() {
    this.onRender?.(this.content);
    return this.content;
  }
}
const createBuilder = (content, onRender) => new Builder(content, onRender);
export {
  createBuilder
};
//# sourceMappingURL=builder.js.map
